import { fade } from '@material-ui/core/styles/colorManipulator';
import { lighten } from '@material-ui/core/styles/colorManipulator';
export const styles = theme => ({
    tableWrapper: {
        width: '100%',
        overflowX: 'auto',
        minHeight: 300
    },
    notiTable: {
        width: '100%',
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    marginBadge: {
        marginLeft: theme.spacing(2),
    },
    headerTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center '
    },
    tableContainer: {
        width: '100%',
    },
    frameTitle: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    paperRoot: {
        marginTop: theme.spacing(2),
        width: '100%'
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    iconEdit: {
        width: '16px',
        height: '16px',
        cursor: 'pointer',
    },
    inputInputSearch: {
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(10),
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 250,
            '&:focus': {
                width: 350,
            },
        },
    },
    icon: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer'
    },
    iconWrap: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer',
        padding: '4px'
    },
    
    root: {
        flexGrow: 1,
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
    },
    suggestion: {
      display: 'block',
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none',
    },
    textCapitalize: {
        textTransform: 'capitalize'
    },
    buttonOnRow: {
        margin: '0.2rem',
        width: '-webkit-fill-available'
    },
    tableCellInCollapes: {
        borderBottom: 'none'
    },
});



export const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',

    },
    subTitle: {
        fontSize: '1.5rem',

    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '20%',
        float: 'right'
    },
    icon: {
        marginTop: theme.spacing(3),
        width: 36,
        height: 36,
        left: -8
    }
});